
// import React from "react";

// const DONATION_FORM_WIDGET_ID = "gJRrA7";
// const DONATE_POPUP_WIDGET_ID = "prWZRn";

// export default function EmbeddedDonationForm() {
//   return (
//     <main className="container py-5">
//       <h1 className="mb-3">Support Our Mission</h1>

//       <p className="text-muted mb-4">
//         Your support helps fund programs and services for children and families.
//       </p>

//       <div className="row g-4 align-items-start">
//         {/* Left: Mission information */}
//         <div className="col-lg-6">
//           <div className="rounded-4 p-4 p-lg-5 bg-primary text-white h-100">
//             <span className="small fw-bold">JGF FUNDRAISING</span>

//             <h2 className="mt-3">Make a Difference Today</h2>

//             <p className="mt-3 mb-0">
//               Your generosity helps support children and families through
//               essential programs and services.
//             </p>

//             {/* Donate popup/modal widget */}
//             <div className="mt-4">
//               <givebutter-widget
//                 id={DONATE_POPUP_WIDGET_ID}
//               ></givebutter-widget>
//             </div>
//           </div>
//         </div>

//         {/* Right: Embedded donation form */}
//         <div className="col-lg-6">
//           <div className="card border-0 shadow-sm rounded-4">
//             <div className="card-body p-4">
//               <h2 className="h4 mb-4">Make a Donation</h2>

//               <givebutter-widget
//                 id={DONATION_FORM_WIDGET_ID}
//               ></givebutter-widget>

//               <p className="small text-muted mt-4 mb-0">
//                 Donations are processed by Givebutter.
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </main>
//   );
// }



import React, { useEffect, useRef, useState } from "react";

// const CHAT_API_URL = "http://localhost:3000/fundraiser/chat";
const CHAT_API_URL = "https://dev.justgen.org:3000/fundraiser/chat";

export default function EmbeddedDonationForm() {
  const [sessionId] = useState(() => String(Date.now()));
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, loading]);

  const sendMessage = async (e) => {
    e.preventDefault();

    const userMessage = message.trim();

    if (!userMessage || loading) return;

    setMessage("");
    setError("");

    setMessages((prev) => [
      ...prev,
      { role: "user", text: userMessage },
    ]);

    setLoading(true);

    try {
      const response = await fetch(CHAT_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          sessionId,
          message: userMessage,
        }),
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const data = await response.json();

      setMessages((prev) => [
        ...prev,
        {
          role: "assistant",
          text: data.reply || "Sorry, I couldn't generate a response.",
          sources: data.sources || [],
          answeredFromKnowledge: data.answeredFromKnowledge ?? false,
        },
      ]);
    } catch (err) {
      setError(
        "Unable to connect to the chatbot. Please try again."
      );
      console.error("Chat API error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-4">
      <div className="card shadow-sm mx-auto" style={{ maxWidth: "800px" }}>
        <div className="card-header bg-primary text-white py-3">
          <h5 className="mb-1">JGF Assistant</h5>
          <small>Just Generation Foundation</small>
        </div>

        <div
          className="card-body bg-light"
          style={{ height: "500px", overflowY: "auto" }}
        >
          {messages.length === 0 && (
            <div className="text-center text-muted py-5">
              <h5>Welcome to JGF Assistant!</h5>
              <p>Ask me anything about the Just Generation Foundation.</p>
            </div>
          )}

          {messages.map((item, index) => (
            <div
              key={index}
              className={`d-flex mb-3 ${
                item.role === "user"
                  ? "justify-content-end"
                  : "justify-content-start"
              }`}
            >
              <div
                className={`rounded-3 p-3 ${
                  item.role === "user"
                    ? "bg-primary text-white"
                    : "bg-white border"
                }`}
                style={{ maxWidth: "85%" }}
              >
                <div className="small fw-semibold mb-1">
                  {item.role === "user" ? "You" : "JGF Assistant"}
                </div>

                <div style={{ whiteSpace: "pre-wrap" }}>
                  {item.text}
                </div>

                {/* {item.role === "assistant" &&
                  item.sources?.length > 0 && (
                    <div className="mt-3 pt-2 border-top">
                      <small className="fw-semibold">
                        Sources
                      </small>

                      <ul className="small mb-0 mt-1 ps-3">
                        {item.sources.map((source, sourceIndex) => (
                          <li key={source.id || sourceIndex}>
                            {source.title}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )} */}

                {/* {item.role === "assistant" &&
                  item.answeredFromKnowledge && (
                    <div className="mt-2">
                      <span className="badge bg-success">
                        Answered from knowledge base
                      </span>
                    </div>
                  )} */}
              </div>
            </div>
          ))}

          {loading && (
            <div className="text-muted small mb-3">
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              />
              JGF Assistant is typing...
            </div>
          )}

          <div ref={messagesEndRef} />
        </div>

        {error && (
          <div className="alert alert-danger mx-3 mt-3 mb-0">
            {error}
          </div>
        )}

        <div className="card-footer bg-white p-3">
          <form onSubmit={sendMessage}>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Ask something about JGF..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                disabled={loading}
                aria-label="Your message"
              />

              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading || !message.trim()}
              >
                {loading ? "Sending..." : "Send"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
